/* global $, jQuery */

// const baguetteBox = require('baguettebox.js');
// import 'owl.carousel';
// require('smoothstate');

$(window).on("load", function () {
  $(".loader-main").addClass("loader-inactive");
});

$(document).ready(function () {
  "use strict";

  const init_template = () => {
    //Disable Page Jump on Empty Links.
    $("a").on("click", function () {
      var attrs = $(this).attr("href");
      if (attrs === "#") {
        return false;
      }
    });

    //Menu System
    $(".menu").each(function () {
      var menuHeight = $(this).data("menu-height");
      var menuWidth = $(this).data("menu-width");
      var menuLoad = $(this).data("menu-load");
      var menuActive = $(this).data("menu-active");
      if (menuLoad !== undefined) {
        $(this).load(menuLoad);
      }
      if ($(this).hasClass("menu-box-right")) {
        $(this).css("width", menuWidth);
      }
      if ($(this).hasClass("menu-box-left")) {
        $(this).css("width", menuWidth);
      }
      if ($(this).hasClass("menu-box-bottom")) {
        $(this).css("height", menuHeight);
      }
      if ($(this).hasClass("menu-box-top")) {
        $(this).css("height", menuHeight);
      }
      if ($(this).hasClass("menu-box-modal")) {
        $(this).css({ height: menuHeight, width: menuWidth });
      }
    });

    //Showing Menu After Page Load
    setTimeout(function () {
      $("#page").css("opacity", "1");
      $(".menu").css("opacity", "1");
      $(".menu").css("display", "block");
      $(".menu-hider").css("display", "block");
    }, 150);

    //Device Has Notch?
    var deviceHasNotch = "false";
    var deviceNotchSize = "44";
    if (deviceHasNotch === "true") {
      $("body").addClass("has-notch");
      $("body").append('<div class="notch-hider"></div>');
      $(".notch-hider").css("height", deviceNotchSize + "px");
      $(
        ".header, body, #page, .menu-box-modal, .menu-box-left, .menu-box-right, .menu-box-top"
      ).css("margin-top", deviceNotchSize + "px");
    }

    //Detect Mobile OS//
    var isMobile = {
      Android: function () {
        return navigator.userAgent.match(/Android/i);
      },
      iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
      },
      Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
      },
      any: function () {
        return isMobile.Android() || isMobile.iOS() || isMobile.Windows();
      },
    };
    if (!isMobile.any()) {
      $("body").addClass("is-not-ios");
      $(".show-ios, .show-android").addClass("disabled");
      $(".show-no-device").removeClass("disabled");
    }
    if (isMobile.Android()) {
      $("body").addClass("is-not-ios");
      $("head").append('<meta name="theme-color" content="#000000"> />');
      $(".show-android").removeClass("disabled");
      $(
        ".show-ios, .show-no-device, .simulate-android, .simulate-iphones"
      ).addClass("disabled");
    }
    if (isMobile.iOS()) {
      $("body").addClass("is-ios");
      $(".show-ios").removeClass("disabled");
      $(
        ".show-android, .show-no-device, .simulate-android, .simulate-iphones"
      ).addClass("disabled");
    }

    //Adding added-to-homescreen class to be targeted when used as PWA.
    if (window.matchMedia("(display-mode: standalone)").matches) {
      $(".add-to-home").addClass("disabled");
      // disable pwa install
    }

    function ath() {
      (function (a, b, c) {
        if (c in b && b[c]) {
          var d,
            e = a.location,
            f = /^(a|html)$/i;
          a.addEventListener(
            "click",
            function (a) {
              d = a.target;
              while (!f.test(d.nodeName)) d = d.parentNode;
              "href" in d &&
                (d.href.indexOf("http") || ~d.href.indexOf(e.host)) &&
                (a.preventDefault(), (e.href = d.href));
            },
            !1
          );
          // disable pwa install
        }
      })(document, window.navigator, "standalone");
    }
    ath();

    //Toggles Switch Styled//
    $("body").on("click", ".toggle-switch", (e) => {
      let $this = $(e.target.parentElement);
      if ($this.hasClass("toggle-off")) {
        $this.removeClass("toggle-off");
        $this.find("strong").css({
          transform:
            "translateX(" +
            ($this.data("toggle-width") - $this.data("toggle-height")) +
            "px)",
        });
        $this
          .find("strong")
          .addClass($this.data("ball-bg") + " no-toggle-border");
        $this
          .find("u")
          .addClass($this.data("bg-on"))
          .removeClass($this.data("bg-off"));
        $("#" + $this.data("toggle-content"))
          .stop()
          .slideDown(250);
        $("#" + $this.data("toggle-checkbox")).prop("checked", true);
      } else {
        $this.addClass("toggle-off");
        $this.find("strong").css({ transform: "translateX(-2px)" });
        $this
          .find("strong")
          .removeClass($this.data("ball-bg") + " no-toggle-border");
        $this
          .find("u")
          .removeClass($this.data("bg-on"))
          .addClass($this.data("bg-off"));
        $("#" + $this.data("toggle-content"))
          .stop()
          .slideUp(250);
        $("#" + $this.data("toggle-checkbox")).prop("checked", false);
      }
      return false;
    });

    //Generating Dynamic Styles to decrease CSS size and execute faster loading times.
    var colorsArray = [
      ["red1", "#D8334A", "#BF263C"],
      ["red2", "#ED5565", "#DA4453"],
      ["orange", "#FC6E51", "#E9573F"],
      ["yellow1", "#FFCE54", "#F6BB42"],
      ["yellow2", "#E8CE4D", "#E0C341"],
      ["green1", "#A0D468", "#8CC152"],
      ["green2", "#2ECC71", "#2ABA66"],
      ["mint", "#48CFAD", "#37BC9B"],
      ["teal", "#A0CECB", "#7DB1B1"],
      ["aqua", "#4FC1E9", "#3BAFDA"],
      ["blue1", "#099BC3", "#0080A2"],
      ["blue2", "#5D9CEC", "#4A89DC"],
      ["magenta1", "#AC92EC", "#967ADC"],
      ["magenta2", "#8067B7", "#6A50A7"],
      ["pink1", "#EC87C0", "#D770AD"],
      ["pink2", "#fa6a8e", "#fb3365"],
      ["brown1", "#BAA286", "#AA8E69"],
      ["brown2", "#8E8271", "#7B7163"],
      ["gray1", "#F5F7FA", "#E6E9ED"],
      ["gray2", "#CCD1D9", "#AAB2BD"],
      ["dark1", "#4a4a4a", "#383838"],
      ["dark2", "#3C3B3D", "#323133"],
    ];
    var opacityArray = [
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
      "55",
      "60",
      "65",
      "70",
      "75",
      "80",
      "85",
      "90",
      "95",
    ];
    var marginArray = [
      "0",
      "1",
      "5",
      "10",
      "15",
      "20",
      "25",
      "30",
      "35",
      "40",
      "45",
      "50",
    ];
    var fontArray = [
      "8",
      "9",
      "10",
      "11",
      "12",
      "13",
      "14",
      "15",
      "16",
      "17",
      "18",
      "19",
      "20",
      "21",
      "22",
      "23",
      "24",
      "25",
      "26",
      "27",
      "28",
      "29",
      "30",
      "31",
      "32",
      "33",
      "34",
      "35",
      "36",
      "37",
      "38",
      "39",
      "40",
    ];
    var fontWArray = [
      "100",
      "200",
      "300",
      "400",
      "500",
      "600",
      "700",
      "800",
      "900",
    ];
    var rotateArray = [
      "0",
      "15",
      "30",
      "45",
      "60",
      "75",
      "90",
      "105",
      "120",
      "135",
      "150",
      "165",
      "180",
    ];
    var scaleArray = [
      ["10", "1.1,1.1"],
      ["20", "1.2,1.2"],
      ["30", "1.3,1.3"],
      ["40", "1.4,1.4"],
      ["50", "1.5,1.5"],
      ["60", "1.6,1.6"],
      ["70", "1.7,1.7"],
      ["80", "1.8,1.8"],
      ["90", "1.9.1.9"],
      ["100", "2,2"],
    ];
    var generatedStyles = $(".generated-styles");

    $("[data-change-highlight]").on("click", function (changeColor) {
      var highlightNew = $(this).data("change-highlight");

      $("body").attr("data-highlight", highlightNew);
      $(".generated-highlight").remove();
      var data = colorsArray.map((colorsArray) => colorsArray[0]);
      if (data.indexOf(highlightNew) > -1) {
        var highlightLocated = data.indexOf(highlightNew);
        if ($(this).data("color-light") !== undefined) {
          var highlightColorCode = colorsArray[highlightLocated][1];
        } else {
          var highlightColorCode = colorsArray[highlightLocated][2];
        }
        var highlightColor =
          ".color-highlight{color:" + highlightColorCode + "!important}";
        var highlightBg =
          ".bg-highlight{background-color:" +
          highlightColorCode +
          "!important}";
        var highlightNav =
          ".active-nav{background-color:" + highlightColorCode + "!important}";
        var highlightBorder =
          ".border-highlight{border-color:" +
          highlightColorCode +
          "!important}";
        $("body").append('<style class="generated-highlight"></style>');
        $(".generated-highlight").append(
          highlightColor,
          highlightBg,
          highlightNav,
          highlightBorder
        );
      }
    });

    if (!generatedStyles.length) {
      $("body").append('<style class="generated-styles"></style>');
      $(".generated-styles").append(
        "/*Generated using JS for lower CSS file Size, Easier Editing & Faster Loading*/"
      );
      colorsArray.forEach(function (colorValue) {
        $(".generated-styles").append(
          ".bg-" +
            colorValue[0] +
            "-light{ background-color: " +
            colorValue[1] +
            "!important; color:#FFFFFF!important;} .bg-" +
            colorValue[0] +
            "-light i, .bg-" +
            colorValue[0] +
            "-dark i{color:#FFFFFF;} .bg-" +
            colorValue[0] +
            "-dark{  background-color: " +
            colorValue[2] +
            "!important; color:#FFFFFF!important;} .border-" +
            colorValue[0] +
            "-light{ border-color:" +
            colorValue[1] +
            "!important;} .border-" +
            colorValue[0] +
            "-dark{  border-color:" +
            colorValue[2] +
            "!important;} .color-" +
            colorValue[0] +
            "-light{ color: " +
            colorValue[1] +
            "!important;} .color-" +
            colorValue[0] +
            "-dark{  color: " +
            colorValue[2] +
            "!important;}"
        );
      });
      colorsArray.forEach(function (gradientValue) {
        $(".generated-styles").append(
          ".bg-gradient-" +
            gradientValue[0] +
            "{background-image: linear-gradient(to bottom, " +
            gradientValue[1] +
            " 0, " +
            gradientValue[2] +
            " 100%)}"
        );
      });
      opacityArray.forEach(function (opacityValues) {
        $(".generated-styles").append(
          ".opacity-" + opacityValues + "{opacity:" + opacityValues / 100 + "}"
        );
      });
      marginArray.forEach(function (marginValues) {
        $(".generated-styles").append(
          ".top-" +
            marginValues +
            "{margin-top:" +
            marginValues +
            "px!important} .bottom-" +
            marginValues +
            "{margin-bottom:" +
            marginValues +
            "px!important} .left-" +
            marginValues +
            "{margin-left:" +
            marginValues +
            "px!important} .right-" +
            marginValues +
            "{margin-right:" +
            marginValues +
            "px!important}"
        );
      });
      fontArray.forEach(function (fontValues) {
        $(".generated-styles").append(
          ".font-" + fontValues + "{font-size:" + fontValues + "px!important;}"
        );
      });
      fontWArray.forEach(function (fontWeightValues) {
        $(".generated-styles").append(
          ".font-" +
            fontWeightValues +
            "{font-weight:" +
            fontWeightValues +
            "!important}"
        );
      });
      scaleArray.forEach(function (scaleVal) {
        $(".generated-styles").append(
          ".scale-" + scaleVal[0] + "{transform:scale(" + scaleVal[1] + ")}"
        );
      });
      rotateArray.forEach(function (rotateVal) {
        $(".generated-styles").append(
          ".rotate-" +
            [rotateVal] +
            "{transform:rotate(" +
            [rotateVal] +
            "deg)!important}"
        );
      });
    }

    //Demo Functions
    var onlineMessage = $(".online-message");
    var offlineMessage = $(".offline-message");
    var detectedOnline = "online-message-active";
    var detectedOffline = "offline-message-active";

    if (!$(".offline-message").length) {
      $("#page").append(
        '<p class="offline-message bg-red2-dark color-white center-text uppercase ultrabold">No internet connection detected</p>'
      );
      $("#page").append(
        '<p class="online-message bg-green1-dark color-white center-text uppercase ultrabold">You are back online. Welcome!</p>'
      );
    }

    var onlineMessage = $(".online-message");
    var offlineMessage = $(".offline-message");
    var offlineMenu = $("#menu-offline");
    var offlineMenuHider = $(".menu-hider");
    var detectedMenu = "menu-active";
    var detectedMenuHider = "menu-active no-click";
    var detectedOnline = "online-message-active";
    var detectedOffline = "offline-message-active";
    function updateOnlineStatus(event) {
      onlineMessage.addClass(detectedOnline);
      offlineMessage.removeClass(detectedOffline);
      offlineMenu.removeClass(detectedMenu);
      offlineMenuHider.removeClass(detectedMenuHider);
      setTimeout(function () {
        onlineMessage.removeClass(detectedOnline);
        offlineMenuHider.removeClass(detectedMenuHider);
      }, 2000);
    }
    function updateOfflineStatus(event) {
      offlineMessage.addClass(detectedOffline);
      offlineMenu.addClass(detectedMenu);
      offlineMenuHider.addClass(detectedMenuHider);
      onlineMessage.removeClass(detectedOnline);
      setTimeout(function () {
        offlineMessage.removeClass(detectedOffline);
        offlineMenuHider.removeClass(detectedMenuHider);
      }, 2000);
    }
    window.addEventListener("online", updateOnlineStatus);
    window.addEventListener("offline", updateOfflineStatus);
  };
  //Activating all the plugins
  setTimeout(init_template, 0);
});



// WEBPACK FOOTER //
// ./src/scripts/custom.js